import { createRouter, createWebHashHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    // name: 'home',
    redirect: '/login'
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/agreement.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/privacy.vue')
  },

  {
    path: '/miniPrograms',
    name: 'miniPrograms',
    redirect: '/miniPrograms/home',
    component: () => import('../views/miniPrograms/miniPrograms.vue'),
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('../views/miniPrograms/home.vue')
      },
      {
        path: 'earningsStatements',
        name: 'earningsStatements',
        component: () => import('../views/miniPrograms/earningsStatements.vue')
      },
      {
        path: 'episodeManagement',
        name: 'episodeManagement',
        component: () => import('../views/miniPrograms/episodeManagement.vue')
      },
      {
        path: 'createNewEpisode',
        name: 'createNewEpisode',
        component: () => import('../views/miniPrograms/createNewEpisode.vue')
      },
      {
        path: 'uploadEpisodes',
        name: 'uploadEpisodes',
        component: () => import('../views/miniPrograms/uploadEpisodes.vue')
      },
      {
        path: 'uploadVideoDetail',
        name: 'uploadVideoDetail',
        component: () => import('../views/miniPrograms/uploadVideoDetail.vue')
      },
      {
        path: 'payouts',
        name: 'payouts',
        component: () => import('../views/miniPrograms/payouts.vue')
      }
      
    ]
  },

  // {
  //   path: '/404',
  //   name: '404',
  //   component: () => import('../views/404.vue')
  // },
  // {
  //   path: '/:catchAll(.*)', redirect: '/404'
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  // console.log(to,from,'撒旦');
  
  if (token) {
    if (to.name === 'login') {
      next({ name: 'miniPrograms' });
    } else {
      next();
    }
    next()
  } else {
    if (to.name === 'login' || to.name === 'agreement' || to.name === 'privacy') {
      next();
    } else {
      next({ name: 'login' });
    }
  }
});

export default router
